import React, { useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import FullNameModal from "./FullNameModal";
import ChangePasswordModal from "./ChangePasswordModal";

// SettingsTab Component////////////////////////////////////////////////////
const SettingsTab = () => {
  const [showFullNameModal, setShowFullNameModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  return (
    <div className="container mt-4 mb-8">
      <h5 className="text-uppercase">Change Profile</h5>
      <p className="text-muted d-flex justify-content-between align-items-center">
        You can only change your Full Name
        <FaPencilAlt
          className="text-primary ms-2"
          onClick={() => setShowFullNameModal(true)}
        />
      </p>

      <h5 className="text-uppercase mt-4">Change Password</h5>
      <p className="text-muted d-flex justify-content-between align-items-center">
        You have to know your Old Password
        <FaPencilAlt
          className="text-primary ms-2"
          onClick={() => setShowPasswordModal(true)}
        />
      </p>

      {/* Modals */}
      <FullNameModal
        show={showFullNameModal}
        handleClose={() => setShowFullNameModal(false)}
      />

      <ChangePasswordModal
        show={showPasswordModal}
        handleClose={() => setShowPasswordModal(false)}
      />
    </div>
  );
};

export default SettingsTab;
